












































import {LanguageCodes} from '@/api/TranslationsApi';
import {HeroesVersion} from '@/api/HeroesVersion';
import {tournamentsApi} from '@/api/TournamentsApi';
import {asyncScheduler, from, zip, of} from 'rxjs';
import {switchMap, filter, map} from 'rxjs/operators';
import {Component, Prop, Vue} from 'vue-property-decorator';
import BlankLoader from '@/components/common/BlankLoader.vue';
import CollapsibleTable from '@/components/common/CollapsibleTable.vue';
import Shortcut from '@/components/common/Shortcut.vue';
import {
  generateLangSubscriptions,
  observeProp,
  observeRouteParam,
  watchAsLoadedObservable,
} from '@/components/observe';
import {Route} from 'vue-router';

@Component<QuickAccess>({
  components: {
    BlankLoader,
    CollapsibleTable,
    Shortcut,
  },
  subscriptions() {
    const $route$ = observeProp<Route>(this, '$route');
    const lang$ = observeRouteParam<string>($route$, 'lang');

    return Object.assign(generateLangSubscriptions(lang$), {
      changeLangIcon: lang$.pipe(map((lang) => this.getOppositeLanguage(lang) + '-flag')),
      changeLangRoute: lang$.pipe(switchMap((lang) => of(this.getOppositeLanguageRoute(lang)))),
      currentUserInfo: from(tournamentsApi.getCurrentTournamentUserInfo$(), asyncScheduler),
      secondUserInfo: observeRouteParam($route$, 'userId').pipe(
        filter((x: any) => !!x),
        switchMap((x: any) => from(tournamentsApi.getTournamentUserInfo$(x), asyncScheduler)),
      ),
      isLoaded: zip(
        watchAsLoadedObservable(this, 'currentUserInfo'),
        watchAsLoadedObservable(this, 'secondUserInfo'),
      ).pipe(switchMap(() => of(true))),
    });
  },
})
export default class QuickAccess extends Vue {
  @Prop() public lang!: string;

  public secondUserInfo!: any;
  public currentUserInfo!: any;
  public translate!: any;
  public $route!: any;

  private getOppositeLanguageRoute(lang: string) {
    return {
      name: this.$route.name,
      params: Object.assign(
        this.$route.params,
        {lang: this.getOppositeLanguage(lang)},
      ),
    };
  }

  private getOppositeLanguage(lang: string) {
    return lang === LanguageCodes.English ? LanguageCodes.Russian : LanguageCodes.English;
  }

  get isReady() {
    return !!this.currentUserInfo;
  }

  get isGuest() {
    return this.isReady && this.currentUserInfo.is_guest === true;
  }

  get userId() {
    return !this.isGuest ? this.currentUserInfo.user_id : null;
  }

  get username() {
    return !this.isGuest ? this.currentUserInfo.username : null;
  }

  get isMyRating() {
    return this.$route.params.userId === this.currentUserInfo.user_id;
  }

  get userRatingLabel() {
    return this.secondUserInfo
      ? this.translate.quick_access_shortcut_user_rating.replace('{username}', this.secondUserInfo.username)
      : '';
  }

  get userUnconfirmedReportsLabel() {
    return this.translate
      .quick_access_shortcut_user_unconfirmed_reports
      .replace('{username}', this.$route.params.username);
  }

  get hasUnconfirmedReports() {
    return !this.isGuest
      && this.currentUserInfo
      && this.currentUserInfo.username
      && this.currentUserInfo.heroes[HeroesVersion.Heroes3].unconfirmed_reports_count > 0;
  }

  get hasMyUnconfirmedReports() {
    return this.hasUnconfirmedReports && this.$route.params.username === this.currentUserInfo.username;
  }

  get hasUserUnconfirmedReports() {
    return this.hasUnconfirmedReports && this.$route.params.username;
  }
}
